import type { ESPokemonSingleProduct } from "@ka-nabellinc/tcg-platform-es-schema";

export const getPokemonSingleProductInfoString = (
  data: ESPokemonSingleProduct
) => {
  let infoString = data.product_name;

  if (data.pm_card.pack.expansion_mark) {
    infoString += `[${data.pm_card.pack.expansion_mark}]`;
  }

  infoString += `[${data.pm_card.rarity.rarity_abbreviation}]`;

  return infoString;
};
